// Mock data for testing LIFF functionality outside LINE environment
export const mockProfile = {
  userId: 'U4af4980629...',
  displayName: 'John Doe',
  pictureUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=face',
  statusMessage: 'Hello from LINE!'
};

export const mockTokens = {
  idToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
  accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...',
  decodedToken: {
    iss: 'https://access.line.me',
    sub: 'U4af4980629...',
    aud: '1657460366',
    exp: 1735732800,
    iat: 1735729200,
    email: 'john.doe@example.com',
    name: 'John Doe',
    picture: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=face'
  }
};

export const mockDeviceInfo = {
  os: 'ios',
  language: 'en',
  version: '2.27.1',
  isInClient: true
};

export const isMockMode = () => {
  // Enable mock mode when not in LINE LIFF environment
  return !window.location.href.includes('liff.line.me') && 
         process.env.NODE_ENV === 'development';
};